import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Mixins } from 'web-common/src/shared/styles';

export type TextProps = {
  /** Light theme (White background) */
  light?: boolean;
};

export const Text = styled.input.attrs(() => ({
  type: 'text',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;

export const Number = styled.input.attrs(() => ({
  type: 'number',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;

export const Date = styled.input.attrs(() => ({
  type: 'date',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;
